import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "最终费用（含税）：", -1);
import { ref, watch } from 'vue';
export default {
  __name: 'dynamicInput',
  props: {
    initialValue: {
      type: Number,
      default: 0
    }
  },
  emits: ['confirm'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const isDisabled = ref(true);
    const inputValue = ref(props.initialValue);

    // 监听 initialValue 变化（如果父组件后续修改）
    watch(() => props.initialValue, newVal => {
      inputValue.value = newVal;
    });
    const toggleEdit = () => {
      if (isDisabled.value) {
        // 进入编辑模式
        isDisabled.value = false;
      } else {
        // 保存并退出编辑模式
        isDisabled.value = true;
        emit('confirm', inputValue.value);
      }
    };
    return (_ctx, _cache) => {
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", null, [_hoisted_1, _createVNode(_component_el_input_number, {
        modelValue: inputValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => inputValue.value = $event),
        min: 0,
        step: 1,
        disabled: isDisabled.value,
        precision: 2
      }, null, 8, ["modelValue", "disabled"]), _createVNode(_component_el_button, {
        style: {
          "margin-left": "10px"
        },
        type: "success",
        onClick: toggleEdit
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(isDisabled.value ? '修改' : '保存'), 1)]),
        _: 1
      })]);
    };
  }
};